import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import List from './list.vue'
import ConfigResponse from './config/response.vue'
import ConfigRequest from './config/request.vue'

const basePath = '/v-admin/company-admin/open-api'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_OPEN_API_MANAGEMENT', 'PREMIUM_OPEN_API_MANAGEMENT', 'COMPUTED_COMPANY_HAS_OPEN_API'],
    menu: {
      get label () {
        return i18n.t('admin.openApi.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.openApi.menu'
      }
    },
    {
      path: `${basePath}/:openApiId/config/response`,
      component: ConfigResponse,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.openApi.title.configResponse'
      }
    },
    {
      path: `${basePath}/:openApiId/config/request/add`,
      component: ConfigRequest,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.openApi.title.configRequest'
      }
    },
    {
      path: `${basePath}/:openApiId/config/request/:configId/edit`,
      component: ConfigRequest,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.openApi.title.configRequest'
      }
    }
  ]
}
